import BaseHeaderSubnav from "@olmokit/components/HeaderSubnav";
import "./index.scss";

/**
 * Component: Header subnav
 */
export default function HeaderSubnav(headerselector) {
  BaseHeaderSubnav(headerselector);
}
